import { render, staticRenderFns } from "./OurProductPage.vue?vue&type=template&id=5efa9f94"
import script from "./OurProductPage.vue?vue&type=script&lang=js"
export * from "./OurProductPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports